import _ from "lodash";
import {isDefined} from "@/helper/Value";

export const CAREER_JOB = 'career-job';
export const CAREER_EDUCATION = 'career-education';
export const CAREER_EDUCATION_PROFESSION_ELIGIBLE = 'career-education-profession-eligible';
export const CAREER_EDUCATION_COMPLETED = 'career-education-completed';
export const CAREER_EDUCATION_SCHOOL = 'career-education-school';
export const CAREER_EDUCATION_VALIDITY_ELIGIBLE = 'career-education-validity-eligible';
export const CAREER_EDUCATION_SCOPE_COUNTRIES_ELIGIBLE = 'career-education-scope-countries-eligible';
export const APPLICATION_INVISIBLE = 'application-invisible';
export const WORKING_HOURS_ELIGIBLE = 'working-hours-eligible';
export const SALARY_ELIGIBLE = 'salary-eligible';
export const HOURLY_RATE_ELIGIBLE = 'hourly-rate-eligible';
export const CAREER_LEVEL_ELIGIBLE = 'career-level-eligible';
export const EMPLOYMENT_DURATION_ELIGIBLE = 'employment-duration-eligible';
export const ADDITIONS_INVISIBLE = 'additions-invisible';
export const ADDITIONS_EDUCATION_DISABLE = 'additions-education-disable';
export const APPOINTMENT_DURATION_LONG = 'appointment-duration-long';
export const FUNCTION_NOTHING_ALLOWED = 'function-nothing-allowed';
export const FUNCTION_INDUSTRIAL_SECTOR_MANDATORY = 'function-industrial-sector-mandatory';
export const FUNCTION_INDUSTRIAL_SECTOR_SUPPRESS = 'function-industrial-sector-suppress';
export const FUNCTION_ORGANISATIONAL_AREA_ELIGIBLE = 'function-organisational-area-eligible';

export function hasTag (characteristic, tagId)
{
	return isDefined(
		_.find(characteristic.tags, alloc => alloc.tag.id === tagId)
	);
}
